import React from 'react';

import "./style.sass";

import WallCards from '../../components/WallCards';
import GreetingButton from "./greeting-button"
import CreateSection from './greeting-create-section';

const GreetingByCards = ({ userId, userName, wall, isGreeted }) => {
    const GreetingTitle = ({ cards, isGreeted, userName }) => {
        let title, subTitle;

        if (cards.items.length === 0) {
            title = "Be the first one to greet!"
        } else if (isGreeted === true) {
            title = `Thank you for greeting, ${userName}`
        } else {
            title = "Let's greet together"
            if (cards.items.length > 0) subTitle = " with " + cards.items[0].senderName
            if (cards.items.length > 1) subTitle += ", " + cards.items[1].senderName
            if (cards.items.length > 2) subTitle += " and " + cards.items.length - 2 + " other(s)"
        }

        return (
            <p className='title is-size-3 py-2' style={{ letterSpacing: "0.1em" }}>
                {title}
                {
                    subTitle &&
                    <div className='subtitle is-size-5 pt-2 pb-5'>
                        {subTitle}
                    </div>

                }
            </p>
        )
    }

    return (
        <>
            <section className='hero is-bold has-background-golden'>
                <div className='hero-body'>
                    <div className='container'>
                        <h1 className='py-4 pb-6 has-text-centered section'>
                            <GreetingTitle cards={wall.cards} isGreeted={isGreeted} userName={userName} />
                        </h1>

                        {wall.cards.items.length > 0 &&
                            <div className="pb-5"><WallCards cards={wall.cards.items} occasion={wall.occasion} /></div>
                        }

                        {!isGreeted &&
                            <div className="pb-5">
                                <GreetingButton wallId={wall.id} userId={userId} userName={userName} />
                            </div>
                        }
                    </div>
                </div>
            </section>

            {
                isGreeted && <CreateSection />
            }

        </>
    )

}

export default GreetingByCards;
